import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Notification as CsiNotification } from '../../services/dialog/notification-models';
import { Router } from '@angular/router';
import { DialogService } from '../../services/dialog/dialog.service';
import { ApplicationService } from '../../services/application.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.scss'
})
export class NotificationsComponent implements OnInit {

  cancelButton: string = 'Close';

  constructor(public dialogRef: MatDialogRef<NotificationsComponent>, private router: Router, private dialog: DialogService,
    public app: ApplicationService, @Inject(MAT_DIALOG_DATA) public data: CsiNotification[]) { }

  ngOnInit() {

  }

  cancel() {
    this.dialog.saveOrUpdateNotificationsAccessPage().subscribe({
      next: (response) => console.log("saveOrUpdateNotificationsAccessPage API response: ", response),
      error: () => console.log("saveOrUpdateNotificationsAccessPage API error"),
    });
    this.dialogRef.close();
  }

  goTo() {
    this.cancel();
    this.router.navigate(['/videoTutorial'], { queryParams: { tab: 'cx' } });
  }

}
